import { render, staticRenderFns } from "./CurrencyDropdownField.vue?vue&type=template&id=49ca3a32"
import script from "./CurrencyDropdownField.vue?vue&type=script&lang=ts"
export * from "./CurrencyDropdownField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/PortfolioWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49ca3a32')) {
      api.createRecord('49ca3a32', component.options)
    } else {
      api.reload('49ca3a32', component.options)
    }
    module.hot.accept("./CurrencyDropdownField.vue?vue&type=template&id=49ca3a32", function () {
      api.rerender('49ca3a32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ClientScripts/Components/Dropdowns/CurrencyDropdownField.vue"
export default component.exports